/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
/**
 * @ignore
 * A button providing functionality of wraping/unwraping configured actions
 */
define(['leaflet', '../wrapable'], function(L, Wrapable) {
    'use strict';
    var classes = {
            action: 'tomtom-point-content__action-chooser'
        },
        nonClickedText = 'Show actions',
        clickedText = 'Hide actions';

    return function(clickHandler) {
        var buttonContainer = L.DomUtil.create('div', classes.action),
            textContainer = L.DomUtil.create('span', null, buttonContainer),
            clicked = false;

        textContainer.innerHTML = nonClickedText;

        function changeButtonLabelWhenClicked() {
            clicked = !clicked;
            if (clicked) {
                textContainer.innerHTML = clickedText;
            } else {
                textContainer.innerHTML = nonClickedText;
            }
        }

        if (clickHandler) {
            buttonContainer.addEventListener('click', clickHandler);
            buttonContainer.addEventListener('click', changeButtonLabelWhenClicked);
        }

        return new Wrapable(buttonContainer, function() {
            clicked = false;
            textContainer.innerHTML = nonClickedText;
        });
    };
});



// WEBPACK FOOTER //
// ./services/popupContentGenerator/actions/actionChooser.js